import { Action, createReducer, on } from '@ngrx/store';
import * as LayoutActions from './layout.actions';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export const layoutFeatureKey = 'layout';

export interface State extends EntityState<any>{
  resolution: any;
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>();

export const initialState: State = adapter.getInitialState({
  resolution: null
});


export const reducer = createReducer(
  initialState,

  on(LayoutActions.registerLayout, (state, { payload }) => {
    return adapter.upsertOne(payload, state);
  }),
  on(LayoutActions.unregisterLayout, (state, { payload }) => {
    return adapter.removeOne(payload, state);
  }),

  on(LayoutActions.updateResolutionLayout, (state, { payload }) => {
    return {
      ...state,
      resolution: payload
    }
  })

);

